var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobilePrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "privacyTitle"
  }, "Privacy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "privacyTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10,
    y: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,6 L3,3 C3,1.34314575 4.790861,0 7,0 C9.209139,0 11,1.34314575 11,3 L11,6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePrivacy);
export default __webpack_public_path__ + "static/media/mobile_privacy.5487e15911da673679829b6cbc9afc64.svg";
export { ForwardRef as ReactComponent };